import request from "@/util/http";
import qs from "qs"; // 获取全部岗位列表

export var getAllJobList = function getAllJobList() {
  return request({
    url: "/admin/post/list",
    method: "get"
  });
}; // 获取岗位信息

export var getJobInfo = function getJobInfo(id) {
  return request({
    url: "/admin/post/get/".concat(id),
    method: "get"
  });
}; // 删除岗位

export var handleDelJob = function handleDelJob(id) {
  return request({
    url: "/admin/post/delete/".concat(id),
    method: "delete"
  });
}; // 移出

export var handleOut = function handleOut(postUserId) {
  return request({
    url: "/admin/post/out/".concat(postUserId),
    method: "delete"
  });
}; // 调岗

export var handleTransfer = function handleTransfer(data) {
  return request({
    // headers:{
    //     "Content-Type": "application/json"
    // },
    url: "/admin/post/transfer",
    method: "post",
    data: qs.stringify(data)
  });
}; // 新增或编辑

export var handleSaveOrUpdate = function handleSaveOrUpdate(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/post/saveOrUpdate",
    method: "post",
    data: JSON.stringify(data)
  });
}; // 分页

export var gettHallPostpage = function gettHallPostpage(params) {
  return request({
    url: "/admin/post/page",
    method: "get",
    params: params
  });
};